import { buildControllerRules } from "@gettactic/helpers/src/hook-form/buildControllerRules";
import { buildErrorMessageForName } from "@gettactic/helpers/src/hook-form/buildErrorMessageForName";
import React from "react";
import { Controller, FieldValues } from "react-hook-form";
import { FloorPlanUploadInput } from "./FloorPlanUploadInput";
import { HookFormFloorPlanUploadInputProps } from "./FloorPlanUploadInput.types";

export const HookFormFloorPlanUploadInput = <T extends FieldValues>(
  props: HookFormFloorPlanUploadInputProps<T>
): React.ReactElement => {
  const { form, name, rules, onChange, ...rest } = props;

  return (
    <Controller
      control={form.control}
      name={name}
      rules={buildControllerRules({
        form,
        name,
        rules,
        isRequired: props.isRequired
      })}
      render={({ field, fieldState }) => (
        <FloorPlanUploadInput
          {...rest}
          value={field.value}
          onChange={(file) => {
            field.onChange(file);
            onChange?.(file);
          }}
          error={
            fieldState.error?.message ||
            buildErrorMessageForName(form, name) ||
            undefined
          }
        />
      )}
    />
  );
};
